import React from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

export const PopUpCta: React.FC<PopUpCta> = ({ image, redirections }) => {
  return (
    <div className="content__cta">
      <GatsbyImage
        className="cta__image"
        image={image.node.gatsbyImage}
        title={image.node.title}
        alt={image.node.altText}
      />

      <div className="redirection-container">
        {redirections
          .filter((redirection) => redirection.toggler)
          .map((linkData, index) => {
            const isInnerLink = linkData.type[0] === "inner";

            return isInnerLink ? (
              <Link key={linkData.link + index} to={linkData.link}>
                {linkData.title}
              </Link>
            ) : (
              <a
                key={linkData.link + index}
                href={linkData.link}
                rel="noopener noreferrer"
                target="_blank"
              >
                {linkData.title}
              </a>
            );
          })}
      </div>
    </div>
  );
};
